import { useQuery } from "@tanstack/react-query";
import { editableTextGet } from "common/api/unos_rad/unos_editable_text";
import { QUERY_KEYS } from "constant/react_query";

export const useUnosEditableTextGet = (slug: string) => {
  const { data: editableText } = useQuery(
    [QUERY_KEYS.UNOS_EDITABLE_TEXT_GET, slug],
    async () => {
      const result = await editableTextGet(slug);
      return result;
    },
    { staleTime: Infinity }
  );
  const result =
    typeof editableText !== "undefined" && editableText !== ""
      ? editableText
      : null;
  return result;
};
